import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const ITEM_TYPES = [
  { v: "fg", kind: "finish-goods", labelKey: "finish_goods" },
  { v: "sfg", kind: "semi-finished-goods", labelKey: "semi_finished_goods" },
  { v: "carton", kind: "cartons", labelKey: "cartons" },
  { v: "plastic", kind: "plastics", labelKey: "plastics" },
  { v: "other", kind: "other-items", labelKey: "other_items" },
];

export const WAREHOUSES = [
  { v: "central", labelKey: "wh_central", available: true },
  { v: "stamp", labelKey: "wh_stamp", available: true },
  { v: "printing", labelKey: "wh_printing", available: true },
  { v: "fg_wh", labelKey: "wh_fg_wh", available: true },
  { v: "sfg_wh", labelKey: "wh_sfg_wh", available: true },
  { v: "reject", labelKey: "wh_reject", available: false },
];

export const stockOf = (item, warehouse) =>
  !item ? 0 : warehouse ? Number(item.stock_by_wh?.[warehouse] || 0) : Number(item.stock || 0);

export const todayStr = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
export const monthStartStr = () => `${todayStr().slice(0, 8)}01`;
export const fmtQty = (n) => Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 });

export async function exportCsv(report, params = {}) {
  const { data } = await api.get(`/export/${report}`, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = `${report}-${todayStr().replaceAll("-", "")}.xlsx`;
  a.click();
}

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
